import React, { useEffect, useState } from 'react';
import { ExcelRenderer, OutTable } from 'react-excel-renderer';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Card, CardContent } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  BackButton,
  ViewTitle,
} from '@iarc-programing/emanufac-components/src/components';
import ExcelSheetGenerator from '@iarc-programing/emanufac-components/src/components/ExcelDownload/ExcelSheetGenerator';
import * as actions from '@/redux/actions';

/**
 * @function ImportExcelProduct
 * @description Display a collections or a list of EditProcessTemplateTableView from database
 */

export default function ImportExcelProduct({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const information = useSelector((state) => state.information);
  const [openDownload, setOpenDownload] = useState(false);
  const [columnList, setColumnList] = useState([]);
  const [artifactDataSet, setArtifactDataSet] = useState([]);
  const [inputData, setInputData] = useState({});
  const [allowUploadToServer, setAllowUploadToServer] = useState(false);

  const fileHandler = (event) => {
    const fileObj = event.target.files[0];

    // just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        setInputData({
          cols: resp.cols,
          rows: resp.rows,
        });
        setAllowUploadToServer(true);
      }
    });
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  useEffect(() => {
    const {
      setting: { wms: wmsSetting },
    } = information;

    const tempColumnList = [
      {
        label: 'ลำดับที่',
        value: 'index',
      },
      {
        label: 'รหัสสินค้า',
        value: 'type_code',
      },
      {
        label: 'ขื่อสินค้า',
        value: 'name',
      },
      {
        label: 'หน่วยสินค้า',
        value: 'unit',
      },
      {
        label: 'หมวดหมู่',
        value: 'product_type',
      },
      {
        label: 'ขั้นต่ำของสินค้า',
        value: 'minimum_amount',
      },
    ];

    if (wmsSetting?.productAttribute?.net) {
      tempColumnList.push({
        label: 'ปริมาตรสุทธิ',
        value: 'net',
      });

      tempColumnList.push({
        label: 'หน่วยของปริมาตรสุทธิ',
        value: 'unit_net',
      });
    }

    if (wmsSetting?.productAttribute?.package_size) {
      tempColumnList.push({
        label: 'ขนาดในบรรจุภัณฑ์',
        value: 'packing_size',
      });
    }

    if (wmsSetting?.productAttribute?.package_unit) {
      tempColumnList.push({
        label: 'หน่วยบรรจุภัณฑ์',
        value: 'packing_unit',
      });
    }

    if (wmsSetting?.productAttribute?.prefer_customer) {
      tempColumnList.push({
        label: 'ลูกค้าแนะนำ',
        value: 'prefer_customer',
      });
    }

    if (information?.setting?.wms?.additionalAttribute) {
      _.map(
        information?.setting?.wms?.additionalAttribute,
        (eachAttribute, index) => {
          tempColumnList.push({
            label: eachAttribute?.name,
            value: `additional.${eachAttribute?.name}`,
          });
        },
      );
    }

    const tempArtifact = {};
    _.map(tempColumnList, (each) => {
      tempArtifact[each?.value] = each?.value;
    });

    console.log('Temp Artifact', [tempArtifact]);
    setColumnList(tempColumnList);
    setArtifactDataSet([tempArtifact]);
    return () => {};
  }, [information]);

  const handleOnFileLoad = async () => {
    console.log('File Data');
    console.log('-----');

    // ชื่อของ Key จะอยู่ใน แถวที่ index 1 (แถวที่ 2 ใน Excel) และเอาแถวสุดท้ายออก
    const fileDataKey = inputData?.rows?.[1];
    const fileData = _.initial(_.slice(inputData?.rows, 2));

    console.log('File Data Key', fileDataKey);
    console.log('File Data', fileData);
    const fileInFormat = _.map(fileData, (_fileData) =>
      _.zipObject(fileDataKey, _fileData),
    );

    console.log('File In Format', fileInFormat);
    await dispatch(actions.productCreate({ arr: fileInFormat }));
    history.goBack();
  };

  return (
    <div>
      {renderTitle()}
      <BackButton />
      <div className="my-2">
        <Card>
          <CardContent>
            <div>ดาวน์โหลดเทมเพลต</div>
            <Button
              variant="contained"
              className="my-2"
              onClick={() => setOpenDownload(true)}
            >
              ดาวน์โหลด
            </Button>
            {openDownload ? (
              <ExcelSheetGenerator
                columnList={columnList}
                dataSets={artifactDataSet}
                sheetName={'ProductTemplate'}
                spreadedColumn={''}
              />
            ) : (
              <div></div>
            )}
          </CardContent>
        </Card>
      </div>
      <div className="my-2">
        <Card>
          <CardContent>
            <div>อัพโหลดไฟล์ข้อมูล</div>
            <input type="file" onChange={fileHandler} className="my-2" />
            <div className="flex justify-end">
              {allowUploadToServer && (
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => handleOnFileLoad()}
                >
                  อัพโหลดไปที่เซิฟเวอร์
                </Button>
              )}
            </div>
            {inputData?.rows && (
              <OutTable
                data={inputData?.rows}
                columns={inputData?.cols}
                tableClassName="ExcelTable2007"
                tableHeaderRowClass="heading bg-gray-200"
              />
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

ImportExcelProduct.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

ImportExcelProduct.defaultProps = {
  title: '',
  subtitle: '',
};
